import { render, staticRenderFns } from "./empty-search-results-block.vue?vue&type=template&id=9e3a1050"
import script from "./empty-search-results-block.vue?vue&type=script&lang=js"
export * from "./empty-search-results-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports